

import React from "react";
import Vimeo from '@u-wave/react-vimeo';
import TTDifference from '../../assets/images/VE_TTDifference_10434x12984.jpg'
import $ from 'jquery';
import KeysuccessinfoRules from "../KeysuccessRotations/KeysuccessinfoRules"
import KeysuccessInfoPrizes from "../KeysuccessRotations/KeysuccessInfoPrizes"
import KeysuccessInfoProgress from "../KeysuccessRotations/KeysuccessInfoProgress"

import PdfViewer from "../PdfViewer/react-pdf-viewer.tsx"
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';

import KeysuccessRotation from "../KeysuccessRotations";
import GallerySlider from "../GallerySlider";
import EditAccountForm from "../NavHeader/EditAccountForm";
import InfoComponent from "../Util/InfoComponent";
import { callAnalyticsAPI } from "../../api/user"
import Participants from "../Sme/Participants";
import CreateParticipants from "../Sme/CreateParticipants";
import WelcomeGraphics from "../Util/WelcomeGraphics";

// const toolbarPluginInstance = toolbarPlugin(ToolbarPluginProps);

let baseUrl = "https://virtualexperience.thermatru.com"
baseUrl = baseUrl + "/storage/sections/pdf/1641277213.pdf"

let text = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RJREFUeNrsW+txo0AMhjQAHeAO4CrAHZAO7KvA6cDpICU4Hdgd2FcBvgpwByQVcFJYMiThiKRdQDjWjMZ/MKy+1Wslrefd6GeTP/QHqqoK4GcJnAAvDPfRxfDJ9/0/s0QVhI6Bt8BFZU+5eVc0B8FXZsFD0R440yZ0ALwBLqvxqFABBCwidaTmUjpOYhpm17eVDkLN24wtfF7po93gYRC9O4Yn4FCpHz5jyIXw+eocAGNrZ8XCv4MAAPyiPnzHSGYOMxAeKeGYg08EIDeZnIxeXsBwwHLO5/r3fxQCvklS8/29LRDPoAm/XTi9nTxIQZRaQW6Er+FyAL52A+lFYRVlVy4yO5ngcSwTvIvT1AaIVCp8xM7uSng8y9wJ3qURsqwxkABw5B1ZIDWIomGE/6wNZTlsjmBSXAbGRb1DQwvfMJoXn2IOAAVL7V3aO5VXbPd0HMbxDWXzFOb7hJQU88mve3qaTviG93t3WmAqOXS7n1r4JjrwnGLUlwqvyY5ivdaR+L7CuefhgfOPtb3zw0RHw+63mZ4oFZ0aYFRjQcuyn/UdgR4fqU8uOqtIZO+P9qZt9xtfIDgjtH0A7bTXd5qb2hccDmQtuD4A3kohZ+qTyy4AQscfGZ/omxN+KYigYdD+GtbqppGCoC6+UCpBQDIAfN9TTWQxakHuvB9ONwBuAHApUtylFqytDQAthiwWegGgr+0k14Ak0QuAYG18DdAMwHJppQEX0l/tOzbDJUF0AC5yDcBMMMv0AYAbE4ZsDbiegkhOLmXmfWHwQLa1NNWz+7gWum869ZXEYlb/T0shhNc3jL85SzCaItLOr0vebt02R1iNkam6Qg1jU2aIdjmrKzx2X7DdH+T1AwrGkbri9ZzG6gzbdYh5sZs9CjeWOfCbovTG6CcAUvZndA5IlOJpUvE0KDYsXfoF1KxcPJtpl7ayJ0U+zGXs7MwCbf0o/zz2rx3UGN9GY+0GojFSYLxGgb5TczQhbLvbTYeR7Z46J6h9RPZL98IjjsySCiLwor+mm3KZgfAnjzkvzDUHjZPiVhPj1wLCbjQda12T0XJhYpoKjUmWygmFz1XcJjMJ09iXplaqXK+ZLXZ1V7BXcNHs78hgZOaOnzMHJ576dpEI2ThLkz8gs6/OenO+PnujmdA/AQYAKG5/WVyvYeIAAAAASUVORK5CYII='

class DisplayData extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            type: null,
            vimeoUrl: null,
            contentParentInfo: props.modalInfoObjSelected,
            modalContentInfo: props.modalContentInfo,
            previousModalContent: null,
            height: window.innerHeight,
            width: window.innerWidth,
            isVideoPaused: props.isVideoPaused,
            pdfcolor: 'red',
            videoPlayedSeconds: 0,
            videoTotalDuration: 0
        }
        if (props.modalContentInfo.color != undefined) {
            this.state.pdfcolor = props.modalContentInfo.color;
        }


    }

    componentDidUpdate(prevProps) {


        if (this.props.modalContentInfo !== this.state.modalContentInfo) {
            //video started ending
            if (this.props.videStarted) {
                const reqData = {}
                let user_id = sessionStorage.getItem("user_id");

                if (user_id) {
                    reqData.user_id = user_id;
                    reqData.area_id = prevProps.modalInfoObjSelected.ref;
                    reqData.resource_id = prevProps.modalContentInfo.navigation_ref
                    reqData.resource_type = "video";
                    reqData.prev_area = 0;
                    reqData.spent_time = this.props.videoPlayedSeconds;
                    reqData.total_time = this.props.videoTotalDuration;
                    reqData.video_status = "Ended";
                    reqData.download = 0;
                    reqData.guided_mode = 0;
                    callAnalyticsAPI(reqData)
                    this.props.changeVIdeoStatus(false)

                }


            }

            this.setState({ type: this.props.modalContentInfo.type, modalContentInfo: this.props.modalContentInfo, contentParentInfo: this.props.modalContentInfo })

        }


        if (this.state.isVideoPaused !== this.props.isVideoPaused) {
            this.setState({ isVideoPaused: this.props.isVideoPaused })
        }


    }
    componentWillUnmount(){

        window.removeEventListener('resize', () => { this.resize(); });

    }
    componentDidMount() {
        window.addEventListener('resize', () => { this.resize(); });
        this.setModalContent()


    }
    setModalContent = () => {
        this.setState({ type: this.props.modalContentInfo.type })
    }

    changeImage = (imgsrc, clsname) => {
        $("#popupimg1 img").attr('src', "")
        $("#popupimg1 img").attr('src', imgsrc)
        $("#popupimg1").removeClass()
        $("#popupimg1").addClass(clsname)
    }



    resize = () => {

      //  this.setState({ height: window.innerHeight, width: window.innerWidth })
    }

    changeloader = (status) => {
        this.props.loaderStatus(status)
    }

    handleVimeoEnd = (e) => {

        const reqData = {}
        let user_id = sessionStorage.getItem("user_id");

        if (user_id) {
            reqData.user_id = user_id;
            reqData.area_id = this.props.modalInfoObjSelected.ref;
            reqData.resource_id = this.props.modalContentInfo.navigation_ref
            reqData.resource_type = "video";
            reqData.prev_area = 0;
            reqData.spent_time = e.duration;
            reqData.total_time = e.duration;
            reqData.video_status = "Ended";
            reqData.download = 0;
            reqData.guided_mode = 0;
            callAnalyticsAPI(reqData)
            this.props.changeVIdeoStatus(false)
        }

    }

    handleVimeoPlay = (e) => {

        //call analytics

        // const reqData = {}
        // let user_id = sessionStorage.getItem("user_id");

        // if(user_id) {
        //     reqData.user_id = user_id;
        //     reqData.area_id = this.props.modalInfoObjSelected.area;
        //     reqData.resource_id = this.props.modalContentInfo.navigation_ref
        //     reqData.resource_type = "video";
        //     reqData.prev_area = "";
        //     reqData.spent_time = 0;
        //     reqData.total_time = e.duration;
        //     reqData.video_status = "Started";
        //     reqData.download = 0;
        //     reqData.guided_mode = 0;
        //     callAnalyticsAPI(reqData)
        //     this.props.changeVIdeoStatus(true)
        // }

        this.props.changeVIdeoStatus(true)
        if (this.state.isVideoPaused) {

            this.props.changevideoPlayStatus(false)

        }
    }
    DownloadCount = () => {
        const link = document.createElement('a');
        link.href = this.state.modalContentInfo.path;
        link.target = '_blank';
        link.setAttribute(
            'download',
            this.state.modalContentInfo.path,
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }

    render() {
        const wMark = this.state.width * 0.02, hMark = this.state.height * 0.06
        if (this.props.modalContentInfo.color != undefined && this.props.modalContentInfo.color === 'blue') {
            text = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5QTFRFAAAA////DnzBAHnCBHjABne//+/vmsrnmsDdM3exogC3vAAAAAp0Uk5TAP///////////36JFFYAAAECSURBVHic7ZXRDcIwDESTDRJVFQMwQWsQg3QCZmEEFkZQJznHTiIVPrm/9p7ujGgc536quCs0bB+zTAR8k4hSivCxTyg/xm6BijACJGH5CJgBOEUGzkR0WXVEekOsOiIFbFQRQQYQSEbsDxMCCwJeB9AVO3ZgFgBHBGigStChJ3jrngFvA6XjA5xqnzsyoAIAsBtSRwIeI0D7tI4A+gMG8DyQIP+L6RvANzrkFzUGVMeSgcYQeYR0cDarIbrmwYAG8/ByQMDjP+sAuR86C4Q7yhS8HcoW4+cp/ZKbDIA9KvJhDTYWKaxaGyi+HeFQ/QI7wrk+Mbq0htee9scXKxC2fVQvY3C38vDhRcIAAAAASUVORK5CYII=';
        } else {
            text = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2RJREFUeNrsW+txo0AMhjQAHeAO4CrAHZAO7KvA6cDpICU4Hdgd2FcBvgpwByQVcFJYMiThiKRdQDjWjMZ/MKy+1Wslrefd6GeTP/QHqqoK4GcJnAAvDPfRxfDJ9/0/s0QVhI6Bt8BFZU+5eVc0B8FXZsFD0R440yZ0ALwBLqvxqFABBCwidaTmUjpOYhpm17eVDkLN24wtfF7po93gYRC9O4Yn4FCpHz5jyIXw+eocAGNrZ8XCv4MAAPyiPnzHSGYOMxAeKeGYg08EIDeZnIxeXsBwwHLO5/r3fxQCvklS8/29LRDPoAm/XTi9nTxIQZRaQW6Er+FyAL52A+lFYRVlVy4yO5ngcSwTvIvT1AaIVCp8xM7uSng8y9wJ3qURsqwxkABw5B1ZIDWIomGE/6wNZTlsjmBSXAbGRb1DQwvfMJoXn2IOAAVL7V3aO5VXbPd0HMbxDWXzFOb7hJQU88mve3qaTviG93t3WmAqOXS7n1r4JjrwnGLUlwqvyY5ivdaR+L7CuefhgfOPtb3zw0RHw+63mZ4oFZ0aYFRjQcuyn/UdgR4fqU8uOqtIZO+P9qZt9xtfIDgjtH0A7bTXd5qb2hccDmQtuD4A3kohZ+qTyy4AQscfGZ/omxN+KYigYdD+GtbqppGCoC6+UCpBQDIAfN9TTWQxakHuvB9ONwBuAHApUtylFqytDQAthiwWegGgr+0k14Ak0QuAYG18DdAMwHJppQEX0l/tOzbDJUF0AC5yDcBMMMv0AYAbE4ZsDbiegkhOLmXmfWHwQLa1NNWz+7gWum869ZXEYlb/T0shhNc3jL85SzCaItLOr0vebt02R1iNkam6Qg1jU2aIdjmrKzx2X7DdH+T1AwrGkbri9ZzG6gzbdYh5sZs9CjeWOfCbovTG6CcAUvZndA5IlOJpUvE0KDYsXfoF1KxcPJtpl7ayJ0U+zGXs7MwCbf0o/zz2rx3UGN9GY+0GojFSYLxGgb5TczQhbLvbTYeR7Z46J6h9RPZL98IjjsySCiLwor+mm3KZgfAnjzkvzDUHjZPiVhPj1wLCbjQda12T0XJhYpoKjUmWygmFz1XcJjMJ09iXplaqXK+ZLXZ1V7BXcNHs78hgZOaOnzMHJ576dpEI2ThLkz8gs6/OenO+PnujmdA/AQYAKG5/WVyvYeIAAAAASUVORK5CYII=';
        }
        return (

            <div className="tab-content" id="myTabContent">

                {
                    this.state.type === 'vimeo' &&

                    <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                        <div className="embed-responsive embed-responsive-16by9">


                            <Vimeo
                                id="vimeo_video"
                                onPlay={this.handleVimeoPlay}
                                video={this.state.modalContentInfo.path}
                                paused={this.state.isVideoPaused}
                                onTimeUpdate={(e) => {

                                    this.props.updateVideoPlayingTime(e)


                                }}
                                onLoaded={() => { this.props.loaderStatus(false)}}
                                onReady={() => {  this.props.loaderStatus(true)}}
                                onEnd={(e) => this.handleVimeoEnd(e)}
                                controls
                                className="vimeo embed-responsive-item"
                            ></Vimeo>


                        </div>
                    </div>

                }

                {
                    this.state.type === 'video' &&

                    <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                        <div className="embed-responsive embed-responsive-16by9">

                            {/* {
                                (this.state.vimeoUrl) && <Vimeo video={this.state.vimeoUrl} autoplay  controls className="vimeo embed-responsive-item"></Vimeo>
                            } */}

                            {

                                <video controls id="videoElment" autoPlay>
                                    <source src={this.state.modalContentInfo.path} type="video/mp4" />
                                </video>

                            }

                        </div>
                    </div>

                }




                {
                    this.state.type === 'pdf' &&

                    <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                        <div className="embed-responsive">
                            <div
                                style={{
                                    border: '1px solid rgba(0, 0, 0, 0.3)',
                                    minHeight: '150px',
                                    height: '70vh',

                                }} >
                                <PdfViewer fileUrl={this.state.modalContentInfo.path}
                                    contentInfo={this.state.modalContentInfo}
                                    contentParentInfo={this.props.modalInfoObjSelected} 
                                    changeLoaderStatus={(status) => { this.props.loaderStatus(status) }} 
                                    />
                            </div>
                        </div>
                    </div>

                }

                {
                    this.state.type === 'image' &&

                    <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                        <div className="popup_div2">
                            <img src={this.state.modalContentInfo.path} alt="" className="w-100" />
                        </div>
                    </div>

                }

                {
                    this.state.type === 'imageArray' &&

                    <div className="popup_div2">
                        <div className="row img-hotspots">

                            {
                                this.state.modalContentInfo.imgArray && this.state.modalContentInfo.imgArray.map((val, index) =>
                                    <div className="col-sm-6 popup-img-array" >

                                        {
                                            index === 0 ? (
                                                <img src={val} alt="" className="w-100" id={`popupimg${index}`} />

                                            ) : (
                                                <div className={this.state.modalContentInfo.classname} id={`popupimg${index}`}>
                                                    <img src={val} alt="" className="w-100" />
                                                </div>
                                            )
                                        }

                                    </div>
                                )

                            }





                            {this.state.modalContentInfo.hotspotNavigationNeed && this.state.modalContentInfo.hotspotNavigationNLocation.map(val =>
                                <div className="modal-hotspot" style={{ top: val.top, left: val.left }} onClick={() => this.changeImage(val.img, val.classname)}>
                                    <div className="modal-hotspot-inner" style={{ width: wMark, height: 'auto', marginTop: -hMark, marginLeft: wMark / -2 }}>


                                        <img src={text} />

                                    </div>
                                </div>
                            )}


                        </div>
                    </div>

                }

                {
                    this.state.type === 'gallery' &&

                    // <GalleryUiComponent imagesarr={this.props.modalContentInfo.images} />
                    <GallerySlider info={this.state.modalContentInfo} imagesarr={this.props.modalContentInfo.images} />
                }

                {
                    this.state.type === 'keysuccess-rules' &&

                    <KeysuccessinfoRules changeModalPopupDisplayData={(val) => this.props.changeModalPopupDisplayData(val)} />

                }

                {
                    this.state.type === 'keysuccess-progress' &&

                    <KeysuccessInfoProgress 
                            changeRender360Map={this.props.changeRender360Map}
                            changeModalPopupDisplayData={(val) => this.props.changeModalPopupDisplayData(val)} 
                            changeLoaderStatus={(status) => { this.props.loaderStatus(status) }} />

                }

                {
                    this.state.type === 'keysuccess-prize' &&

                    <KeysuccessInfoPrizes changeModalPopupDisplayData={(val) => this.props.changeModalPopupDisplayData(val)} />

                }

                {
                    this.state.type === 'keysuccess-rotation' &&

                    <KeysuccessRotation changeModalPopupDisplayData={(val) => this.props.changeModalPopupDisplayData(val)} changeLoaderStatus={(status) => { this.props.loaderStatus(status) }} />

                }


                {

                    this.state.type === "navigation_box" &&
                    <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">

                        <div className="popup_div3 modal_description_div">
                            <div className="popup_top_line"></div>
                            <div className="py-4">{this.state.modalContentInfo.discription}</div>

                            {
                                this.state.modalContentInfo.childNavigation.map(val => <a className="btn veris_btn" href="" ><span>{val}</span></a>)
                            }


                        </div>
                    </div>
                }

                {
                    this.state.type === "profile_edit" && <EditAccountForm changeLoaderStatus={(status) => { this.props.loaderStatus(status) }} />
                }

                {
                    this.state.type === "web_info" && <InfoComponent />
                }

                {
                    this.state.type === "welcome_info" && <WelcomeGraphics />
                }

                {
                    this.state.type === "sme" && <Participants changeModalPopupDisplayData={(val) => { this.props.changeModalPopupDisplayData(val) }} />
                }


                {
                    this.state.type === "sme_add" && <CreateParticipants changeModalPopupDisplayData={(val) => { this.props.changeModalPopupDisplayData(val) }} />
                }


                {
                    this.state.type === '' &&

                    <div className="tab-pane fade show active" role="tabpanel" aria-labelledby="home-tab">
                        <div className="popup_div2">
                            <img src={TTDifference} alt="" className="w-100" />
                        </div>
                    </div>

                }


            </div>
        )
    }
}


export default DisplayData;